import { Injectable } from '@angular/core';
import { ApiService } from '../../../../shared/services/api/api.service';
import { IGetMemberFilter, IMember } from '../interfaces/interface';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  constructor(private readonly apiService: ApiService) {}

  getMembers(filter: IGetMemberFilter) {
    return this.apiService.post<IMember[]>('member-search', filter);
  }

  getMembersWithDetails(filter: IGetMemberFilter) {
    return this.apiService.post<IMember[]>('member-search/get-with-details', filter);
  }

  getMemberDetail(memberId: number) {
    return this.apiService.get<any>(`member-search/get-member-detail/${memberId}`);
  }

  getServicesOfMember(contractId: number) {
    return this.apiService.get<any>(`member-search/get-services-of-members/${contractId}`);
  }

  getNumberOfServiceRights(contractId: number) {
    return this.apiService.get<any>(`member-search/get-number-of-service-rights/${contractId}`);
  }

  getMemberMailInfo(contractId: number, serviceId: number) {
    return this.apiService.get<any>(`member-search/member-get-mail-info/${contractId}/${serviceId}`);
  }

  sendMemberMail(mailData: {from:string, to:string, cc:string, subject:string, htmlContent:string}) {
    return this.apiService.post<{success:boolean}>('member-search/send-member-mail', mailData);
  }

  getServiceProducts(packageId: number) {
    return this.apiService.get<{products:any[],instructions:any[]}>(`member-search/get-service-products-instructions/${packageId}`);
  }

  createService(data:CreateProductServiceDto){
    return this.apiService.post<{sonuc:boolean}>('member-search/create-service', data);
  }

  updateService(data:UpdateProductServiceDto){
    return this.apiService.patch<{success:boolean}>('member-search/update-service', data);
  }

  deleteService(serviceId:number){
    return this.apiService.delete<{success:boolean}>(`member-search/delete-service/${serviceId}`);
  }
}


export interface CreateProductServiceDto {
  subscriberId: number;
  contractId: number;
  productId: number;
  productDetailId?: number;
  instructionId?: number;
  protocol?: string;
  description?: string;
  date: string; // Format: YYYY-MM-DD
}


export interface UpdateProductServiceDto {
  serviceId: number;
  subscriberId: number;
  followNumber: number;
  isBillCome: boolean;
  contractId: number;
  productId: number;
  productDetailId?: number;
  instructionId?: number;
  protocol?: string;
  description?: string;
  date: string; // Format: YYYY-MM-DD
}
